<template>
  <div class="teaching-arrange-setting-scale">
    <DataGrid size="mini"
              border="none"
              :data="scales">
      <DataGridColumn title="课程类别"
                      field="name"
                      align="center">
      </DataGridColumn>
      <DataGridColumn v-for="scaleType in scaleTypes"
                      :key="scaleType.value"
                      :title="scaleType.label"
                      align="center">
        <template #default="{row}">
          <el-input v-model.number="row[scaleType.value]"
                    size="mini"
                    type="number"
                    :disabled="disabled">
            <template slot="append">%</template>
          </el-input>
        </template>
      </DataGridColumn>
      <template #empty>
        <span>没有可设置的课程类别</span>
      </template>
    </DataGrid>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import objectUtils from '../../../../../../../../../util/objectUtils'
export default {
  name: 'TeachingArrangeSettingScale',
  components: {
    DataGrid,
    DataGridColumn
  },
  props: {
    scales: Array,
    disabled: Boolean
  },
  data () {
    return {
      scaleTypes: [{
        label: '平时成绩比例',
        value: 'usualScoreScale'
      }, {
        label: '考试成绩比例',
        value: 'examScoreScale'
      }, {
        label: '作业成绩比例',
        value: 'workScoreScale'
      }, {
        label: '实践报告比例',
        value: 'reportScoreScale'
      }, {
        label: '案例分析比例',
        value: 'caseScoreScale'
      }]
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        const scales = this.scales
        if (scales && scales.length) {
          let valid = scales.every(scale => {
            let v = this.scaleTypes.every(t => {
              let v = scale[t.value]
              if (!objectUtils.hasValue(v)) {
                reject(new Error(`请填写${scale.name}${t.label}`))
                return
              }
              if (v < 0) {
                reject(new Error(`${scale.name}${t.label}不能小于0`))
                return
              }
              if (v !== Math.round(v)) {
                reject(new Error(`${scale.name}${t.label}不能填写小数`))
                return
              }
              return true
            })
            if (!v) {
              return
            }
            let s = this.scaleTypes.reduce((p, t) => {
              return scale[t.value] + p
            }, 0)
            if (s !== 100) {
              reject(new Error(`${scale.name}成绩比例之和不等于100`))
              return
            }
            return true
          })
          if (!valid) {
            return
          }
          let result = scales.map(s => {
            let data = {
              courseTypeId: s.id
            }
            this.scaleTypes.forEach(t => {
              data[t.value] = s[t.value]
            })
            return data
          })
          resolve(result)
        } else {
          reject(new Error('没有可设置的课程类别'))
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .teaching-arrange-setting-scale {
    .vxe-table {
      .vxe-table--header-wrapper {
        margin-bottom: 5px;
        .vxe-table--header {
          .vxe-header--row {
            background-color: #f3f4f5;
          }
        }
      }
      .vxe-table--body-wrapper {
        .vxe-table--body {
          .vxe-body--row {
            .vxe-body--column {
              .vxe-cell {
                .el-input {
                  .el-input-group__append {
                    color: #303133;
                    padding: 0 6px;
                  }
                }
              }
            }
          }
        }
      }
      .vxe-table--empty-placeholder {
        margin-top: 1px;
        background-color: #fcfcfc;
      }
    }
  }
</style>
